import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=3dcd6a86&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dcd6a86')) {
      api.createRecord('3dcd6a86', component.options)
    } else {
      api.reload('3dcd6a86', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=3dcd6a86&", function () {
      api.rerender('3dcd6a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Pagination/pagination.vue"
export default component.exports